export const RINGCENTRAL_RECORDS_INITIAL_PAGE = 1;
export const RINGCENTRAL_RECORDS_PAGE_SIZE = 10;
export const RINGCENTRAL_BACKFILL_DEFAULT_LOOKBACK_DAYS = 1;
export const RINGCENTRAL_RECORDING_MEDIA_GROUP_ORDER = 0;
export const RINGCENTRAL_TRANSCRIPT_MEDIA_GROUP_ORDER = 1;
